import { Button, CircularProgress, Container, Grid, makeStyles, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import firebase from "firebase";
import { LocalPrintshopSharp, TableChart } from '@material-ui/icons';
import TablePaginationActions from '@material-ui/core/TablePagination/TablePaginationActions';
import emailjs from "emailjs-com";
import _ from 'underscore';

function AdminPrijaveGosti() {

    //firebase
    const db = firebase.database();



    //stlyes
    const useStyles = makeStyles({
      table: {
        minWidth: 650,
      },
    });

    const classes = useStyles();

    //FirstLoad
    let firstLoad = true;

    //Gosti
    const [gosti, setGosti] = useState(null)
    const [prikazGosti,setPrikazGosti] = useState(null)

    const [needsReRendering,setNeedsReRendering] = useState(false);

    const [odobreniGosti,setOdobreniGosti] = useState(false);

    //pages
    
    const [page,setPage] = useState(0);
    const [rowsPerPage,setRowsPerPage] = useState(10);
    const [numOfGuests,setNumOfGuests] = useState(0)

    //pages handler
    const handleChangePage = (event,newPage) => {
      setPage(newPage);
    }

    //rows handler
    const handleChangeRowsPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10))
      setPage(0);
    }



    useEffect(() => {

      if(needsReRendering){setNeedsReRendering(false)}

      if(firstLoad){

        if(gosti==null){
          firebase.database().ref('Gosti').once('value').then((promise)=>{
            if(_.isUndefined(promise.val()) || _.isNull(promise.val())){
              setGosti([]) 
              setPrikazGosti([])
            }
            else{
              setGosti(promise.val())
            }
            })
        }
        else{
          if(_.isNull(gosti)|| _.isUndefined(gosti)){
            setPrikazGosti([]);
            setNumOfGuests(0);
            firstLoad=false
          }
          else if(_.isNull(gosti.prijave)|| _.isUndefined(gosti.prijave)){
            setPrikazGosti([]);
            setNumOfGuests(0);
            firstLoad=false
          }
          else{
            setNumOfGuests(Object.keys(gosti.prijave).length)
            setPrikazGosti(gosti.prijave)
            firstLoad=false

          }
         
        }
      }

  

    },[gosti,needsReRendering])


   //DISPLAY PRIJAVE GOSTI 
   function handlePrijave(){
    setPage(0);
    setOdobreniGosti(false)
    if(_.isNull(gosti.prijave)|| _.isUndefined(gosti.prijave)){
      setPrikazGosti([]);
      setNumOfGuests(0);
    }
    else{
      setPrikazGosti(gosti.prijave)
      setNumOfGuests(Object.keys(gosti.prijave).length)
    }
    
 
  }


  //DISPLAY ODOBRENI GOSTI
  function handleOdobrenePrijave(){
    setPage(0);
    setOdobreniGosti(true)
     if(_.isNull(gosti.odobreni)|| _.isUndefined(gosti.odobreni)){
      setPrikazGosti([]);
      setNumOfGuests(0);
    }else{

 
    setPrikazGosti(gosti.odobreni)
    setNumOfGuests(Object.keys(gosti.odobreni).length)
  }
  }


    const OdobriModal = (props)=>{

      const  storageRef = firebase.storage().ref();

      const {obj,submit,close,ID} = props;

      const [date,setDate] = useState(new Date().toISOString().substring(0,10))

      const [fileUrl,setFileUrl] = useState("-1")

      const [uploadPercent,setUploadPercent] = useState(0)

      function handleUpload(e){
        let potvradaPlaćanja = e.target.files[0]

        let uploadTask = storageRef.child('/Gosti/Potvrde/' + ID + '/'+ potvradaPlaćanja.name).put(potvradaPlaćanja);
        
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            setUploadPercent((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          },
          function(errors){},
          function(){
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              console.log('File available at', downloadURL);
              setFileUrl(downloadURL)
              setUploadPercent(0)
            });
          }
        )
      }

      function cancelChanges(){
        if(fileUrl!="-1"){
          firebase.storage().refFromURL(fileUrl).delete() 
        }
        
        close()
      }


      function saveChanges(){
        let bool = window.confirm("Jeste li sigurni da želite odobri " + obj.name + " " + obj.surname + " ?")
        if(!bool){
          cancelChanges()
        }

        let submitGuest =obj;
        submitGuest.payed = true;
        submitGuest.payDate = date
        submitGuest.potvrda = fileUrl;

        submit(submitGuest)

        
      }
      return <React.Fragment>

        <Grid
            style={{
              backgroundColor:"white",
              border:"5px solid lightblue",
          
             
            
            }}
        container
        direction="column"
        >
          {
            obj==null?
          <CircularProgress/>:
          <React.Fragment>
          <Grid item >
            <Typography variant="h4" style={{textAlign:"center"}}>PODACI O GOSTU</Typography>
          </Grid>


          <Container style={{textAlign:"left",justifyContent:"center"}}>
           
          <Grid item style={{paddingTop:"20px"}}>
            <Typography>Ime: {obj.name}</Typography>
          </Grid>

          <Grid item style={{paddingTop:"20px"}}>
            <Typography>Prezime: {obj.surname}</Typography>
          </Grid>
          
         <Grid item style={{paddingTop:"20px"}}>
            <Typography>Email: {obj.email}</Typography>
          </Grid>

          <Grid item style={{paddingTop:"20px"}}>
            <TextField type="date" onChange={(e)=>{setDate(e.target.value)}} value={date}></TextField>
          </Grid>

          <Grid item style={{paddingTop:"20px"}}>
            <Typography>Dodajte potvrdu plaćanja</Typography>
            {uploadPercent==0?null:uploadPercent+"%"}
            <TextField type="file" onChange={handleUpload} ></TextField>
          </Grid>
         
          </Container>

          <Grid item  style={{paddingTop:"20px",textAlign:"center"}}>
            <Button disable={uploadPercent!=0} onClick={saveChanges} variant="contained" color="primary" style={{width:"40%",margin:"10px",backgroundColor:"#45B283 "}}>Odobri gosta</Button>
            <Button onClick={cancelChanges} variant="contained" color="primary" style={{width:"40%",backgroundColor:"#9A4E43"}}>Odustani</Button>
          </Grid>
          </React.Fragment>
            }

        </Grid>

      </React.Fragment>
      

    }
  

    const Red = (props)=>{
        const {gost,id,indx} = props


    
        const [openModal,setOpenModal] = useState(false);


        function handleCloseModal(){
          setOpenModal(false)
          setOpenModal(false)
        }

        function deleteGost(){
          
          firebase.database().ref('Gosti/prijave/'+id).remove()
          window.location.reload(false)
        }
        function deleteOdobreniGost(){
         
          firebase.database().ref('Gosti/odobreni/'+id).remove()
          window.location.reload(false)
        }

        const  handleSubmit = (submitGuest)=> {
       
          let odobreniGost = submitGuest
          let newState = gosti
          if(_.isUndefined(newState.odobreni)|| _.isNull(newState.odobreni)){
            newState.odobreni={}
          }
            
        
          delete newState.prijave[id];
  
          newState.odobreni[id] = gost;

          setGosti(newState)
          setNeedsReRendering(true)

          //Firebase
          firebase.database().ref('Gosti/prijave/'+id).remove()
          
          firebase.database().ref('Gosti/odobreni/'+id).set(gost)
          .then(()=>{
            emailjs
            .send(
              "serviceProba",
              "OdobreniGost",
              {
  
                email: odobreniGost.email,
              },
              "user_hU4wKMTGiLWs2jfLyPHR4"
            )
            .then((res) => {
              // TODO SPINNER AND DISABLE PAGE
            
         
            })
            .catch((err) => {
              alert("Pogreška pri slanju Pokušaj te kasnije ponovno");
              console.log(err);
            });
  
          })



        }
      
  
        return <React.Fragment> 
          <TableRow>
            <TableCell component="th" scope="row">{1+indx+page * rowsPerPage} </TableCell>   

            <TableCell align="right">{gost.name}</TableCell>

            <TableCell align="right">{gost.surname}</TableCell>

            <TableCell align="right">{gost.email}</TableCell>

            <TableCell align="right">{gost.submitDate}</TableCell>


          
            <TableCell align="right">{gost.payed?  new Date(gost.payDate).toLocaleDateString():"Nije uplaćeno"}</TableCell>

            <TableCell align="right">{gost.payed?"Uplaćeno":"Nije uplaćeno"}</TableCell>


            <TableCell>
              <Button variant="contained" color="primary"  
              onClick={()=>{setOpenModal(true)}} 
              style={{backgroundColor:"#45B283",marginTop:"5px",display:gost.payed?"none":"default"}}>Odobri</Button>
            </TableCell>

            <TableCell>
              <Button variant="contained" color="primary"  
              onClick={()=>{deleteGost()}} 
              style={{backgroundColor:"#9A4E43",marginTop:"5px",display:gost.payed?"none":"default"}}>X</Button>
            </TableCell>

            <TableCell>
              <Button variant="contained" color="primary"  
              onClick={()=>{deleteOdobreniGost()}} 
              style={{backgroundColor:"#9A4E43",marginTop:"5px",display:odobreniGosti?"default":"none"}}>X</Button>
            </TableCell>

        
            {/* START MODAL */}
            <React.Fragment>
              <Modal
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{margin:"100px auto",width:"50%",}}
             
              >
                <div><OdobriModal submit={handleSubmit} obj={gost} close={handleCloseModal} ID ={id}/></div>
            
              </Modal >
            </React.Fragment>
             {/* END MODAL */}


        </TableRow>
      </React.Fragment>

       
    }


 
    
    if(prikazGosti===null) return <CircularProgress/>

    return (
        <div>
            <Button id="gosti" onClick={handlePrijave}><Typography variant="h3" style={{borderBottom:odobreniGosti?"":"3px solid #45B283",

          }}
            >Gosti</Typography></Button>
            <Button id="odGosti"onClick={handleOdobrenePrijave}><Typography variant="h3" style={{borderBottom:!odobreniGosti?"":"3px solid #45B283",
            
          }}>Odobreni gosti</Typography></Button>

            <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell align="right">Ime</TableCell>
            <TableCell align="right">Prezime</TableCell>
            <TableCell align="right">Email</TableCell>
            <TableCell align="right">Datum prijave</TableCell>
            <TableCell align="right">Datum plaćanja</TableCell>
            <TableCell align="right">Status plaćanja</TableCell>
            <TableCell align="right"></TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>


        {gosti === null ? <CircularProgress/> : 
        
        <TableBody>
            {
            Object.keys(prikazGosti)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((i,indx)=>{
              return <Red id = {i} gost = {prikazGosti[i]} indx={indx}/>
                }
              )  
            }

        </TableBody>
        }
        

      </Table>
     
        <TablePagination
        count={numOfGuests}
        page={page}
        onChangePage={handleChangePage}
        rowsPerPage = {rowsPerPage}
        onChangeRowsPerPage = {handleChangeRowsPage}
        rowsPerPageOptions = {[10,25,100]}
        />
      
    </TableContainer>





        </div>
    )
}

export default AdminPrijaveGosti
